
import AtAGlanceTab from "@/components/project-reports/evaluation-report/AtAGlanceTab.vue";
import AnalysisTab from "@/components/project-reports/evaluation-report/AnalysisTab.vue";
import ComparisonTab from "@/components/project-reports/evaluation-report/ComparisonTab.vue";
import SummaryNextStepsTab from "@/components/project-reports/evaluation-report/SummaryNextStepsTab.vue";
import VueI18n from "vue-i18n";

import { TypedVue } from "@/store/types";
import { Component, Inject, Prop } from "vue-property-decorator";
import { ProjectTheme, ProjectReportData, EvaluationReportData, V2Project } from "@/store/admin/adminTypes";
import { sortAssessments } from "@/components/project-reports/evaluation-report/shared";

@Component({
  components: {
    AtAGlanceTab,
    AnalysisTab,
    ComparisonTab,
    SummaryNextStepsTab,
  },
})
export default class EvaluationReport extends TypedVue {
  public reportData: EvaluationReportData | null = null;
  private tabIndex = 0;
  public printing = false;

  // Labels are literals so the team can rename tabs (e.g. "Next steps" → "For Discussion") in Retool.
  public tabs = [
    { key: "fit", label: "Tabs::FitToRole" },
    { key: "comparison", label: "Tabs::Comparison" },
    { key: "profile", label: "Tabs::Profile" },
    { key: "next", label: "Tabs::NextSteps" },
  ];

  // Shadows the global $i18n with the per-report instance provided by the view,
  // so $t() also resolves the merged project-report:search-report literals.
  @Inject("$i18n") readonly $i18n!: VueI18n;

  @Prop({ required: true })
  readonly report!: ProjectReportData;

  @Prop({ required: true })
  readonly project!: V2Project;

  get projectTheme(): ProjectTheme {
    return (this.project?.theme as ProjectTheme) ?? ProjectTheme.DEFAULT_TA;
  }

  // Managers, then team members, then candidates ranked by match score.
  get sortedAssessments() {
    return this.reportData ? sortAssessments(this.reportData) : [];
  }

  async mounted() {
    this.reportData = this.report.data as EvaluationReportData;
    window.addEventListener("beforeprint", this.onBeforePrint);
    window.addEventListener("afterprint", this.onAfterPrint);
  }

  viewGuide(): void {
    window.open("https://assets.system-3.com/web-assets/report/search-report-guide.pdf");
  }

  // Same approach as TeamEffectivenessReportV2: render every tab (expanding collapsibles
  // and one radar per candidate) before the browser snapshots the page.
  print(): void {
    this.printing = true;
    this.$nextTick(() => {
      setTimeout(() => {
        window.print();
      }, 600);
    });
  }

  // Plain methods (not arrow class fields): vue-class-component binds methods to the live
  // component, whereas arrow fields capture a throwaway instance and the flag never updates.
  onBeforePrint(): void {
    this.printing = true;
  }

  onAfterPrint(): void {
    this.printing = false;
  }

  beforeDestroy() {
    window.removeEventListener("beforeprint", this.onBeforePrint);
    window.removeEventListener("afterprint", this.onAfterPrint);
  }
}
